import React from "react";

const galleryImages = [
  {
    id: 1,
    src: "assets/img/attachments/IMG-20241025-WA0033.jpg",
    location: "tvm",
    category: "drinks events",
  },
  {
    id: 2,
    src: "assets/img/attachments/IMG-20241025-WA0034.jpg",
    location: "tmc",
    category: "events",
  },
  {
    id: 3,
    src: "assets/img/attachments/IMG-20241026-WA0022.jpg",
    location: "kollam",
    category: "drinks foods",
  },
  {
    id: 4,
    src: "assets/img/attachments/IMG-20241026-WA0024.jpg",
    location: "changanacherry",
    category: "events",
  },
  {
    id: 5,
    src: "assets/img/attachments/IMG-20241026-WA0025.jpg",
    location: "kilimanoor",
    category: "pastries events",
  },
  {
    id: 6,
    src: "assets/img/attachments/IMG-20241026-WA0032.jpg",
    location: "kottarakara",
    category: "foods",
  },
  {
    id: 7,
    src: "assets/img/attachments/IMG-20241026-WA0026.jpg",
    location: "nagercoil",
    category: "foods drinks",
  },
  {
    id: 8,
    src: "assets/img/attachments/IMG-20241026-WA0027.jpg",
    location: "mavelikara",
    category: "pastries",
  },
  {
    id: 9,
    src: "assets/img/attachments/IMG-20241026-WA0028.jpg",
    location: "tvm",
    category: "events",
  },
  {
    id: 10,
    src: "assets/img/attachments/IMG-20241026-WA0028.jpg",
    location: "pathanamthitta",
    category: "foods",
  },
  {
    id: 11,
    src: "assets/img/attachments/IMG-20241026-WA0023.jpg",
    location: "ranni",
    category: "drinks",
  },
  {
    id: 12,
    src: "assets/img/attachments/IMG-20241026-WA0031.jpg",
    location: "tuticorin",
    category: "foods",
  },
];

const Gallery = () => {
  return (
    <div>
      <section className="wrapper bg-[#edf2fc]">
        <div className="container pt-10 pb-10 xl:pt-[4.5rem] lg:pt-[4.5rem] md:pt-[4.5rem] xl:pb-15 lg:pb-15 md:pb-15 text-center">
          <div className="flex flex-wrap mx-[-15px]">
            <div className="md:w-10/12 lg:w-8/12 xl:w-8/12 w-full flex-[0_0_auto] px-[15px] max-w-full mx-auto">
              <h1 className="text-[calc(1.365rem_+_1.38vw)] font-bold leading-[1.2] xl:text-[2.4rem] mb-3">
                Gallery
              </h1>
              <p className="lead lg:px-5 xl:px-5 leading-[1.65] text-[0.9rem] font-medium max-w-full">
                ECHS (Ex-Servicemen Contributory Health Scheme){" "}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-10 xl:pt-10 wrapper bg-white border-b border-[rgba(164,174,198,0.2)]">
        <div className="container text-center">
          <div className="itemgrid grid-view">
            {/* All Images Section */}
            <div className="flex flex-wrap mx-[-15px] justify-center">
              {galleryImages.map((image) => (
                <div
                  key={image.id}
                  className="xl:w-4/12 lg:w-4/12 md:w-6/12 w-full flex-[0_0_auto] px-[15px] mt-[30px] max-w-full"
                >
                  <figure>
                    <a className="relative block z-[3] cursor-pointer h-64">
                      <img
                        src={image.src}
                        alt={`ECHS Polyclinic ${image.location.toUpperCase()}`}
                        className="w-full h-full object-cover rounded"
                      />
                    </a>
                  </figure>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
